const SET_TIER_OPTIONS = "SET_TIER_OPTIONS";

export const setTierOptions = (payload) => {
    return {
        type: SET_TIER_OPTIONS,
        payload,
    };
};

const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_TIER_OPTIONS:
            if (!action.payload) {
                return initialState;
            }
            return [...action.payload];

        default:
            return state;
    }
};
